import type { ReactElement, ReactNode } from 'react';
import { AppearanceToggle } from '../shell/appearance';
import '../../styles/login.css';

export function AuthLayout({ children }: { readonly children: ReactNode }): ReactElement {
  return <div className="login-page" data-density="comfortable">
    {/* Mesmo tema da barra lateral (mineral-nav): o login e o app compartilham o painel escuro. */}
    <aside className="login-brand" data-theme="mineral-nav" aria-label="Pieltec Revestimentos Técnicos">
      <img className="login-brand__logo" src="/brand/logo-branco-recorte.png" alt="Pieltec Revestimentos Técnicos" />
      <div className="login-brand__message"><p className="login-eyebrow">GESTÃO INDUSTRIAL</p>
        <h1>Precisão na operação.<br />Clareza na gestão.</h1>
        <p>Conecte cada etapa da produção em um só lugar. Do pedido à entrega, com controle e rastreabilidade.</p>
      </div>
      {/* Marca d'água com o triângulo do símbolo Pieltec (contorno + plano translúcido). */}
      <svg className="login-brand__mark" viewBox="0 0 900 800" aria-hidden="true">
        <defs>
          <linearGradient id="login-mark-stroke" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#1e4f7c" /><stop offset=".5" stopColor="#56b2c5" /><stop offset="1" stopColor="#1e4f7c" />
          </linearGradient>
        </defs>
        <polygon points="430,10 640,520 90,450" fill="#4485a1" fillOpacity=".09" />
        <polygon points="20,20 860,135 330,780" fill="none" stroke="url(#login-mark-stroke)" strokeOpacity=".28" strokeWidth="38" strokeLinejoin="miter" />
      </svg>
      <p className="login-brand__footer">Produção · Qualidade · Planejamento</p>
    </aside>
    <section className="login-access">
      <div className="login-theme"><AppearanceToggle /></div>
      <main className="login-page__card">
        <img className="login-access__logo" src="/brand/logo-recorte.png" alt="Pieltec Revestimentos Técnicos" />
        {children}
      </main>
      <p className="login-access__footer">Pieltec · Revestimentos Técnicos</p>
    </section>
  </div>;
}
